module.exports = __webpack_public_path__ + "static/img/16.311e954.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/16.png
// module id = 38r6
// module chunks = 0